import React from "react";
import "./LuxuryGrid.css";

interface GridItem {
  id: number;
  title: string;
  text: string;
  icon?: React.ElementType;
}

interface LuxuryGridProps {
  items?: GridItem[];
}

export default function LuxuryGrid({ items = [] }: LuxuryGridProps) {
  return (
    <section className="luxury-grids">
      <div className="grid-container">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <div key={item.id} className="grid-card">
              <div className="grid-icon">
                {Icon ? <Icon size={38} color="#e8ddc1" /> : item.id}
              </div>
              <h3 className="grid-title">{item.title}</h3>
              <p className="grid-text">{item.text}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
